import React from 'react'
import classNames from 'classnames'

type Props = React.PropsWithChildren<{
    icon: JSX.Element
    iconIsPrerendered?: boolean
}>

export function PersonalInfoRow(props: Props) {
    return (
        <div className="AppCore__ui__UserProfile__PersonalInfoRow">
            <div className="AppCore__ui__UserProfile__PersonalInfoRow-smallPanel">
                <div
                    className={classNames('AppCore__ui__UserProfile__PersonalInfoRow-iconContainer', {
                        'AppCore__ui__UserProfile__PersonalInfoRow-iconContainer--IsPreRendered':
                            props.iconIsPrerendered,
                    })}
                >
                    {props.icon}
                </div>
            </div>
            <div className="AppCore__ui__UserProfile__PersonalInfoRow-largePanel">{props.children}</div>
        </div>
    )
}
